import { getDeviceType } from '@fil-global/eiswagen';

import { DEVICE_RESIZE, PAGE_TRANSITION } from './constants';

export const onDeviceResize = ({ deviceType }) => ({
  type: DEVICE_RESIZE,
  data: deviceType || getDeviceType(),
});

export const pageTransitionAction = ({ match }) => ({
  type: PAGE_TRANSITION,
  page: match ? match.path : '',
});
